import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Navbar.css';

const Navbar = ({ searchvalue }) => {
  const [searchInput, setSearchInput] = useState('');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchInput.trim() === '') {
      toast.error('Please write text in search!');
    } else {
      searchvalue(searchInput);
      navigate(`/SearchResult/${searchInput}`);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSearch(e);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <div>
      {/* Overlay for mobile menu */}
      {isMenuOpen && (
        <div 
          className="menu-overlay"
          onClick={closeMenu}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 999
          }}
        />
      )}

      {/* Side Menu */}
      <div 
        className={`side-menu ${isMenuOpen ? 'side-menu-open' : ''}`}
        style={{
          position: 'fixed',
          top: 0,
          left: isMenuOpen ? '0' : '-250px',
          width: '250px',
          height: '100vh',
          backgroundColor: '#f0f0f0',
          boxShadow: '2px 0 5px rgba(0,0,0,0.1)',
          transition: 'left 0.3s ease',
          zIndex: 1000,
          paddingTop: '70px'
        }}
      >
        <div className="menu-content" style={{ padding: '20px' }}>
          <div className="menu-item" style={{ marginBottom: '15px' }}>
            <Link 
              to="/" 
              onClick={closeMenu}
              style={{
                display: 'flex',
                alignItems: 'center',
                textDecoration: 'none',
                color: '#333',
                padding: '10px',
                borderRadius: '5px',
                transition: 'background-color 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
            >
              <i className="fa-solid fa-home" style={{ marginRight: '10px', width: '20px' }}></i>
              Home
            </Link>
          </div>
          
          <div className="menu-item" style={{ marginBottom: '15px' }}>
            <Link 
              to="/saved-playlists" 
              onClick={closeMenu}
              style={{
                display: 'flex',
                alignItems: 'center',
                textDecoration: 'none',
                color: '#333',
                padding: '10px',
                borderRadius: '5px',
                transition: 'background-color 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
            >
              <i className="fa-solid fa-bookmark" style={{ marginRight: '10px', width: '20px' }}></i>
              Saved Playlists
            </Link>
          </div>

          {/* Add more menu items here if needed */}
          <hr style={{ margin: '20px 0' }} />
          
          <div className="menu-item">
            <div style={{
              padding: '10px',
              color: '#666',
              fontSize: '12px'
            }}>
              <i className="fa-solid fa-info-circle" style={{ marginRight: '5px' }}></i>
              Your saved playlists are stored locally
            </div>
          </div>
        </div>
      </div>

      {/* Main Navbar */}
      <nav className="navbar das fixed-top">
        <div className="container-fluid">
          <div className="d-flex align-items-center">
            {/* Menu Toggle Button */}
            <button
              className="btn btn-link menu-toggle"
              onClick={toggleMenu}
              style={{
                border: 'none',
                background: 'none',
                fontSize: '18px',
                color: '#333',
                marginRight: '15px',
                padding: '5px 10px'
              }}
            >
              <i className="fa-solid fa-bars"></i>
            </button>
            
            {/* Logo */}
            <Link className="logo" to="/">
              <img
                src="https://icones.pro/wp-content/uploads/2021/02/youtube-logo-icone-bleue.png"
                alt="Logo"
                height={40}
                width={40}
              />
            </Link>
          </div>

          {/* Search Section */}
          <div className="d-flex float-right">
            <input
              className="form-control me-1 search-input "
              type="search"
              placeholder="Search"
              aria-label="Search"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              onKeyDown={handleKeyPress}
            />
            <button className="btn btn-light btn-outline-success" onClick={handleSearch}>
              <i className="fa-solid fa-magnifying-glass text-black"></i>
            </button>
          </div>
        </div>
      </nav>

      <style jsx>{`
        .menu-toggle:hover {
          background-color: #f5f5f5 !important;
          border-radius: 5px;
        }
        
        .side-menu-open {
          left: 0 !important;
        }
        
        @media (max-width: 768px) {
          .side-menu {
            width: 200px !important;
          }
        }
        
        .menu-item a:hover {
          background-color: #f5f5f5 !important;
        }
      `}</style>
    </div>
  );
};

export default Navbar;